import PropTypes from 'prop-types';
import React from 'react';
import { duplicationText } from '../../constants/projectDuplication.js';
import CheckIcon from '../icons/CheckIcon.jsx';
import { CloseIcon } from '../icons/CloseIcon.jsx';
import styles from './DuplicationToasts.module.css';

const DuplicationToast = ({ duplication, onOpenProject, onClose }) => {
  const completed = duplication.status === 'completed';

  return (
    <div
      role="status"
      className={`${styles.toast} ${completed ? styles.success : styles.danger}`}
    >
      {completed ? (
        <span className={styles.icon}>
          <CheckIcon />
        </span>
      ) : null}
      <div className={styles.content}>
        {/* The failure message from the backend already starts with "Duplication failed." */}
        {completed ? (
          <strong className={styles.title}>
            {duplicationText('successTitle')}
          </strong>
        ) : null}
        <p className={styles.body}>
          {completed
            ? duplicationText('successBody', {
                name: duplication.targetProjectName,
              })
            : duplication.errorMessage}
        </p>
        {completed && duplication.targetProjectId ? (
          <button
            type="button"
            className={`btn-clear bg-transparent text-primary ${styles.link}`}
            onClick={() => onOpenProject(duplication)}
          >
            {duplicationText('openProject')}
          </button>
        ) : null}
      </div>
      <button
        type="button"
        className={`btn-clear bg-transparent ${styles.close}`}
        onClick={() => onClose(duplication)}
        aria-label="Close"
      >
        <CloseIcon />
      </button>
    </div>
  );
};

// Finished duplications stay on screen until the user closes them or opens the copy.
const DuplicationToasts = ({ duplications, onOpenProject, onClose }) =>
  duplications.length ? (
    <div className={styles.stack}>
      {duplications.map((duplication) => (
        <DuplicationToast
          key={duplication.id}
          duplication={duplication}
          onOpenProject={onOpenProject}
          onClose={onClose}
        />
      ))}
    </div>
  ) : null;

DuplicationToasts.propTypes = {
  duplications: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      status: PropTypes.string.isRequired,
      targetProjectId: PropTypes.number,
      targetProjectName: PropTypes.string,
      errorMessage: PropTypes.string,
    })
  ).isRequired,
  onOpenProject: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default DuplicationToasts;
